module.exports = __webpack_public_path__ + "static/logo--high-detail-014382f3702e807ab2af9b49bbec9bb4.svg";